import styled from 'styled-components';

export const StyledRegulationContainer = styled.div`
  width:  100%;
  background: #FFFFFF;
  border: 1px solid #EDEDF3;
  box-sizing: border-box;
  box-shadow: 0px 1px 1px rgba(136, 138, 152, 0.25);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  padding: 18px;
  margin-top: 8px;
  cursor: pointer;

  img.open {
    margin-top: 6px;
    width: 12px;
    height: 12px;
  }
`;

export const StyledRegulationContent = styled.div`
  flex-grow: 1;

  .title {
    font-family: Inter;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
    margin: 0px 4px;
  }

  small {
    display: flex;
    align-items: center;
    font-family: Inter;
    font-style: normal;
    font-size: 12px;
    line-height: 140%;
    color: #888A98;

    img {
      width: 10px;
      height: 10px;
      margin-right: 8px;
    }

    .validity {
      margin-left: 4px;
      color: #14CC52;
      font-weight: 600;
    }
  }
`;
